<info-modal [title]="title" (onOk)="ok()">
	<ngb-pagination
		*ngIf="totalCount > 0"
		[collectionSize]="(totalCount / divide)"
		[maxSize]="10"
		[pageSize]="1"
		[(page)]="currentPage"
		[boundaryLinks]="true"
		(pageChange)="onPageChange()"
	></ngb-pagination>
	
	<loading [isLoad]="detailLoader || !details"></loading>
	
	<ng-container *ngFor="let detail of details; let i = index">
		<br>
		
		<div>
			<strong>
			<ng-container *ngIf="details.length > 1">
				<ng-container *ngIf="currentPage">
					{{ (currentPage - 1) * divide + i + 1 }}.
				</ng-container>
				
				<ng-container *ngIf="!currentPage">
					{{ i + 1 }}.
				</ng-container>
			</ng-container>
			</strong>
			<site_info [siteUrl]="detail.site.domainUrl" style="display: inline-block;"></site_info>
		</div>
		
		<span class="float-right">
			{{ detail.user.useTariffsMixins ? '$7' : '' }}
		</span>
		
		<table class="table">
			<tr>
				<td>
					{{ 'adminstat.billing.billing.owner' | translate }}
				</td>
				
				<td>
					<gotosupport [value]="detail.user.email"></gotosupport> ({{ detail.user.username }})
				</td>
			</tr>
			
			<tr>
				<td>
					{{ 'adminstat.billing.billing.Freemium' | translate }}
				</td>
				
				<td>
					{{ detail.user.allowFreemium ? 'Да' : 'Нет' }}
				</td>
			</tr>
			
			<tr>
				<td>
					{{ 'adminstat.billing.billing.use7' | translate }}
				</td>
				
				<td>
					{{ detail.user.useTariffsMixins ? 'Да' : 'Нет' }}
				</td>
			</tr>
			
			<tr *ngIf="detail.site.promocode">
				<td>
					{{ 'adminstat.common.Promocode' | translate }}
				</td>
				
				<td>
					{{ detail.site.promocode }}
				</td>
			</tr>
		</table>
		
		<hr>
		
		<ngb-accordion #acc="ngbAccordion">
			<ngb-panel [id]="'panel' + i + 'test'" title="{{ 'adminstat.common.billing' | translate }}">
				<ng-template ngbPanelContent>
					<table class="table">
						<thead>
							<tr>
								<th>{{ 'adminstat.common.Date' | translate }}</th>
								<th>{{ 'adminstat.common.invoiceNumber' | translate }}</th>
								<th>{{ 'adminstat.common.Status' | translate }}</th>
								<th>{{ 'adminstat.common.Promocode' | translate }}</th>
								<th>{{ 'adminstat.common.Type' | translate }}</th>
								<th>{{ 'adminstat.billing.billing.tariffId' | translate }}</th>
								<th>{{ 'adminstat.billing.billing.tariffVariant' | translate }}</th>
								<th>$</th>
								<th>{{ 'adminstat.billing.billing.dateTo' | translate }}</th>
								<th>{{ 'adminstat.billing.billing.invoice info' | translate }}</th>
							</tr>
						</thead>
						
						<tbody>
							<tr *ngFor="let paid of detail.paids; let j = index">
								<td id="{{ paid._id }}">
									Дата оплаты: {{ paid.transaction_date }} <br/>
									Дата логирования: {{ paid.time }}
								</td>
								
								<td>
									{{ paid.invoiceNumber }}
								</td>
								
								<td>
								<!--<td ngStyle="{'width': '200px'}">-->
									<ng-container *ngIf="paid.status == 'paid' && paid.tariffId == 'upgrade'">
										{{ paid.migrationFrom }} -> {{ paid.migrationTo }}
									</ng-container>
									
									<ng-container *ngIf="paid.status == 'paid' && paid.paidSource == 'uber'">
										{{ 'adminstat.filterForm.uberSite' | translate }}
									</ng-container>
									
									<ng-container *ngIf="paid.status == 'paid' && paid.tariffId != 'upgrade' && paid.paidSource != 'uber'">
										{{ 'adminstat.billing.billing.invoicePaidType' + paid.invoicePaidType | translate }}
									</ng-container>
									
									<span *ngIf="paid.status != 'paid'" title="{{ ('adminstat.billing.billing.code' | translate) + paid.errorCode + '(' + paid.errorText + ')' }}">
										<ng-container *ngIf="paid.errorCode">
											{{ 'adminstat.billing.billing.code' | translate }}
											<strong>{{ paid.errorCode }}</strong>
											<br>
										</ng-container>
										
										<ng-container *ngIf="paid.errorText">
											<strong>{{ paid.errorText }}</strong>
										</ng-container>
									</span>
								</td>
								
								<td>
									{{ paid.promocodeMark || '' }}
								</td>
								
								<td>
									{{ paid.processorType }}
								</td>
								
								<td>
									{{ paid.tariffId }}
								</td>
								
								<td>
									{{ paid.tariffVariant }}
								</td>
								
								<td>
									<ng-container *ngIf="paid.moneyCount">
										{{ paid.moneyCount / 100 }}$
										<ng-container *ngIf="paid.currency != 'usd'">
											({{ paid.amount / 100 }} {{ paid.currency }})
										</ng-container>
									</ng-container>
								</td>
								
								<td>
									{{ moment(paid.dateTo).tz('Europe/Moscow').format('DD.MM.YYYY HH:mm') }}
								</td>
								
								<td>
									<ngb-accordion #acc="ngbAccordion">
										<ngb-panel [id]="'panel-invoice' + j + 'test'" title="{{ 'adminstat.billing.billing.invoice info' | translate }}">
											<ng-template ngbPanelContent>
												<table class="table">
													<tbody>
														<tr>
															<td>
																{{ 'adminstat.billing.billing.invoiceId' | translate }}
															</td>
															
															<td>
																{{ paid.invoiceId }}
															</td>
														</tr>
														
														<tr>
															<td>
																{{ 'adminstat.billing.billing.rec profile' | translate }}
															</td>
															
															<td>
																{{ paid.recurrentProfile }}
															</td>
														</tr>
														
														<tr>
															<td>
																{{ 'adminstat.billing.billing.rec ok' | translate }}
															</td>
															
															<td>
																{{ paid.recurrentSuccess }}
															</td>
														</tr>
														
														<tr>
															<td>
																{{ 'adminstat.billing.billing.rec fail' | translate }}
															</td>
															
															<td>
																{{ paid.recurrentFails }}
															</td>
														</tr>
													</tbody>
												</table>
											</ng-template>
										</ngb-panel>
									</ngb-accordion>
								</td>
							</tr>
						</tbody>
					</table>
				</ng-template>
			</ngb-panel>
			
			<ngb-panel *ngIf="detail.disabled" [id]="'disabled-panel' + i" title="{{ 'adminstat.billing.billing.disable recurrent' | translate }}">
				<ng-template ngbPanelContent>
					<table class="table">
						<thead>
							<tr>
								<th>{{ 'adminstat.common.Date' | translate }}</th>
								<th>{{ 'adminstat.common.Status' | translate }}</th>
								<th>{{ 'adminstat.common.id' | translate }}</th>
								<th>{{ 'adminstat.billing.billing.invoiceId' | translate }}</th>
							</tr>
						</thead>
						
						<tbody>
							<tr *ngFor="let disable of detail.disabled">
								<td>
									{{ moment(disable.time).tz('Europe/Moscow').format('DD.MM.YYYY HH:mm') }}
								</td>
								
								<td>
									{{ 'adminstat.billing.billing.disable recurrent' | translate }}
								</td>
								
								<td>
									{{ disable._id }}
								</td>
								
								<td>
									{{ disable.invoiceId }}
								</td>
							</tr>
						</tbody>
					</table>
				</ng-template>
			</ngb-panel>
			
			<ngb-panel *ngIf="detail.invoices" [id]="'invoices-panel' + i" title="{{ 'adminstat.billing.billing.Invoices' | translate }}">
				<ng-template ngbPanelContent>
					<table class="table">
						<thead>
							<tr>
								<th>{{ 'adminstat.billing.billing._id' | translate }}</th>
								<th>{{ 'adminstat.common.Status' | translate }}</th>
								<th>{{ 'adminstat.billing.billing.dateCreate' | translate }}</th>
								<th>{{ 'adminstat.billing.billing.dateTo' | translate }}</th>
								<th>{{ 'adminstat.billing.billing.recurrentProfile' | translate }}</th>
								<th>{{ 'adminstat.billing.billing.recurrentSuccess' | translate }}</th>
								<th>{{ 'adminstat.billing.billing.recurrentFails' | translate }}</th>
							</tr>
						</thead>
						
						<tbody>
							<tr *ngFor="let invoice of detail.invoices">
								<td>
									{{ invoice._id }}
								</td>
								
								<td>
									{{ invoice.status }}
								</td>
								
								<td>
									{{ moment(invoice.dateCreate).tz('Europe/Moscow').format('DD.MM.YYYY HH:mm') }}
								</td>
								
								<td>
									{{ moment(invoice.dateTo).tz('Europe/Moscow').format('DD.MM.YYYY HH:mm') }}
								</td>
								
								<td>
									{{ invoice.recurrentProfile }}
								</td>
								
								<td>
									{{ invoice.recurrentSuccess }}
								</td>
								
								<td>
									{{ invoice.recurrentFails }}
								</td>
							</tr>
						</tbody>
					</table>
				</ng-template>
			</ngb-panel>
		</ngb-accordion>
	</ng-container>
</info-modal>
